export default __webpack_public_path__ + "static/4-cbf02602df00207d14da2b390d494ef5.png";